// @flow
import React, { createContext, useState, useContext } from "react";
import { Toaster } from "react-hot-toast";
import Routes from "./routes/Routes";
import CustomLoader from "./components/customs/Loader/CustomLoader";

// Themes
import "./assets/scss/Saas.scss";

// 1. Crear el contexto para el Loader
export const LoaderContext = createContext();

// 2. Hook personalizado para usar el loader en cualquier parte
export const useLoading = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoading debe usarse dentro de un LoaderProvider");
  }
  return context;
};

type AppProps = { user: "User" };

const App = (props: AppProps): React$Element<any> => {
  // 3. Estado global que controla el CustomLoader
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      <CustomLoader show={loading} />
      <Toaster position="top-right" />
      <Routes />
    </LoaderContext.Provider>
  );
};

export default App;